const SECOND = 1000
const MINUTE = 60 * SECOND
const HOUR = 60 * MINUTE

function pad(value: number): string {
  return String(value).padStart(2, '0')
}

/**
 * Milissegundos restantes -> "HH:MM:SS". Nunca devolve negativo: passado o fim
 * da janela o contador para em 00:00:00 em vez de contar para trás enquanto a
 * próxima leitura do estado não chega.
 */
export function formatCountdown(remainingMs: number): string {
  const safe = Number.isFinite(remainingMs) && remainingMs > 0 ? remainingMs : 0

  const hours = Math.floor(safe / HOUR)
  const minutes = Math.floor((safe % HOUR) / MINUTE)
  const seconds = Math.floor((safe % MINUTE) / SECOND)

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}

/** Milissegundos entre agora e o fim da janela; 0 quando não há fim conhecido. */
export function remainingUntil(endsAt: string | null, now: number): number {
  if (!endsAt) return 0

  const end = new Date(endsAt).getTime()
  if (Number.isNaN(end)) return 0

  return Math.max(0, end - now)
}
